<template>
  <div>
    <div>
      <!-- Story Modal -->
      <b-toast
        id="story-sidebar-toast-skip"
        toast-class="story-sidebar-toast-wrapper"
        body-class="story-sidebar-toast"
        :visible="showSkipToast"
        :auto-hide-delay="5000"
        :no-close-button="true"
        @hidden="showSkipToast=false"
      >
        Story skipped to end, click Argo for training options
      </b-toast>
      <b-modal
      id="story-modal"
      hide-header
      hide-footer
      size="lg"
      :modal-class="'story-modal-component'"
    >
      <div class="story-modal">
        <img v-if="Progression.storyIndex < Object.keys(storyInstructions.myZoombiesNfts[Progression.stepIndex].story).length - 1"
              class="confirm-next-button-image-1"
              src="./assets/panel-next-button.png"
        />
        <button
          v-if="Progression.storyIndex < Object.keys(storyInstructions.myZoombiesNfts[Progression.stepIndex].story).length - 1"
          class="confirm-next-button-1"
          @click="replacePanelText"
        >
        continue
        </button>
        <button
          v-else
          class="confirm-next-button-2"
          @click="completePanelText"
        >
          <img class="confirm-next-button-image-2" src="./assets/panel-confirm-button.png"/>
        </button>
        <typewriter ref="typewriter" class="typewriter" :type-interval="1" :replace-interval="1">
          <div class="typewriter-text">
            {{storyInstructions.myZoombiesNfts[Progression.stepIndex].story[Progression.storyIndex]}}
          </div>
        </typewriter>
        <button class="skip-button" @click="skipStoryProgress">
          skip
        </button>
      </div>
      </b-modal>

      <!-- Open Booster Modal -->
      <b-modal
        id="open-booster-modal"
        size="lg"
        no-close-on-backdrop
        hide-header
        content-class="booster-modal"
        ok-variant="danger"
        ok-title="Open Booster"
        hide-footer
      >
        <div class="modal-content">
          <div class="open-booster-modal">
            <div class="form-description">
              Slide the handle to enter ZOOM burn wager amount & increase the
              probabilty of pulling better rarity:
            </div>
            <div class="form-group d-flex justify-content-center align-items-center">
              <b-form-input
                v-model="wagerAmount"
                class="form-control"
                :state="isWagerValid"
                required
                type="range"
                min="0"
                max="20000000"
                step="1"
                :style="{ width: '60%', align: 'center' }"
                @input="calculateProbability"
              />
            </div>
            <div style="margin-bottom: 15px"></div>
            <div class="d-flex justify-content-center">
              <b-progress
                show-progress
                :max="pBarMax"
                height="30px"
                class="mb-3"
                :style="{ width: '60%' }"
              >
                <b-progress-bar
                  v-b-tooltip.hover="
                    wagerAmount == 0
                      ? `0.01% chance to pull an Epic`
                      : `${
                          pBarWagerValues[0].toFixed(2) / 1
                        }% chance to pull an Epic`
                  "
                  class="p-bar-purple"
                  :value="wagerAmount == 0 ? 1 : pBarWagerValues[0]"
                ></b-progress-bar>
                <b-progress-bar
                  v-b-tooltip.hover="
                    `${
                      pBarWagerValues[1].toFixed(2) / 1
                    }% chance to pull a Rare`
                  "
                  variant="danger"
                  :value="pBarWagerValues[1]"
                ></b-progress-bar>
                <b-progress-bar
                  v-b-tooltip.hover="
                    `${
                      pBarWagerValues[2].toFixed(2) / 1
                    }% chance to pull an Uncommon`
                  "
                  variant="primary"
                  :value="pBarWagerValues[2]"
                ></b-progress-bar>
                <b-progress-bar
                  v-b-tooltip.hover="
                    `${
                      pBarWagerValues[3].toFixed(2) / 1
                    }% chance to pull a Common`
                  "
                  variant="secondary"
                  :value="pBarWagerValues[3]"
                ></b-progress-bar>
              </b-progress>
            </div>
            <div v-if="getZoomBalance == 0" class="no-zoom-text d-flex justify-content-center align-items-center"> <!-- SHOW when no ZOOM-->
              <b-container style="max-width:fit-content">
                <b-alert id="zoomEarn" show variant="danger">No ZOOM tokens ?</b-alert>
                <div>
                  You need 500 ZOOM to open a booster. You can earn ZOOM tokens<br/> 
                  when you Buy credits or Shop Cards, sacrifice NFTs to the ZOOG
                </div><br/>
              </b-container>
              <b-popover
                target="zoomEarn"
                title="Earn ZOOM"
                triggers="hover"
              >
              There are a number of ways to earn the <strong>ZOOM token</strong>
                <ul>
                  <li>Share your affiliate link, can earn you 20% of affiliate actions</li>
                  <li>Buy Booster credits earn +700 ZOOM per credit</li>
                  <li>Sacrificing an NFT to the great ZOOG force will earn you the value displayed on the back of the card</li>
                </ul>
              </b-popover>
            </div>
            <div v-if="getZoomBalance > 0" class="zoom-wager"> <!-- HIDE if NO ZOOM or wager too high -->
              <img
                src="https://zoombies.world/images/zoombies_coin.svg"
                width="70"
                height="70"
              />
              ZOOM WAGER:
              <span style="color: #00d1ff">{{
                parseInt(wagerAmount).toLocaleString()
              }}</span>
            </div>
            <div v-else style="min-height: 70px;"></div>
            <b-form-invalid-feedback v-if="isWagerValid">
              <div>
                You need to enter a number between 1,000,000 and 20,000,000 to
                wager.
              </div>
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!hasEnoughCZXP">
              <div>You do not have enough ZOOM tokens</div>
            </b-form-invalid-feedback>

            <div v-b-tooltip.hover="!isWagerValid ? 'You do not have enough zoom for this wager' : 'Mint a booster NFT for 500 ZOOM'"
              class="mint-button"
            >
              <button
                block
                :disabled="!isWagerValid || (getBoosterCreditOwned < 1 && getZoomBalance < 500)"
                style="
                  background-color: transparent;
                  border-color: transparent;
                  position: relative;
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                "
                @click="openBooster"
              >
                <img
                  v-if="isWagerValid && getBoosterCreditOwned >= 1 && getZoomBalance >= 500"
                  class="mint-button-image"
                  src="../components/assets/mint_booster_nft.png"
                />
                <img
                  v-else
                  class="mint-button-image-disabled"
                  src="../components/assets/red_button_400.webp"
                />
                <span
                  class="mint-button-text"
                  style="
                    font-family: 'Truculenta', sans-serif;
                    font-weight: 700;
                    font-size: 18px;
                  "
                  >{{ isWagerValid && getBoosterCreditOwned >= 1 && getZoomBalance >= 500 ? 'MINT BOOSTER NFT' : 'NOT ENOUGH ZOOM' }}</span
                >
              </button>
            </div>

            <p class="text-danger-before">
              <span class="text-danger"><strong>NOTE:</strong></span> ZOOM is
              burned permanently when you wager
            </p>

            <div class="min-max-wager">
              <br />Minimum Wager = 1,000,000 &nbsp;&nbsp;&nbsp;&nbsp; Maximum
              Wager = 20,000,000<br />
            </div>

            <div class="default-probability">
              Default probability with NO ZOOM wager
            </div>
            <div class="d-flex justify-content-center">
              <b-progress
                show-progress
                :max="pBarMax"
                height="30px"
                class="mb-3"
                style="width: 55%"
              >
                <b-progress-bar
                  v-b-tooltip.hover="`0.01% chance to pull an Epic`"
                  class="p-bar-purple"
                  :value="pBarDefaultValues[0]"
                ></b-progress-bar>
                <b-progress-bar
                  v-b-tooltip.hover="
                    `${pBarDefaultValues[1]}% chance to pull a Rare`
                  "
                  variant="danger"
                  :value="pBarDefaultValues[1]"
                ></b-progress-bar>
                <b-progress-bar
                  v-b-tooltip.hover="
                    `${pBarDefaultValues[2]}% chance to pull an Uncommon`
                  "
                  variant="primary"
                  :value="pBarDefaultValues[2]"
                ></b-progress-bar>
                <b-progress-bar
                  v-b-tooltip.hover="
                    `${pBarDefaultValues[3]}% chance to pull a Common`
                  "
                  variant="secondary"
                  :value="pBarDefaultValues[3]"
                ></b-progress-bar>
              </b-progress>
            </div>
            <div class="close-button">
              <button
                block
                style="
                  background-color: transparent;
                  border-color: transparent;
                  position: relative;
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                "
                @click="$bvModal.hide('open-booster-modal')"
              >
                <img src="../components/assets/close-button.png" />
                <span
                  class="close-button-text"
                  style="
                    font-family: 'Truculenta', sans-serif;
                    font-weight: 700;
                    font-size: 18px;
                  "
                  >Close</span
                >
              </button>
            </div>
          </div>
        </div>
      </b-modal>
      
      <!-- Buy Booster Modal -->
      <b-modal
        id="buy-boosters-modal"
        hide-header
        hide-footer
      >
        <div class="booster-modal-content">
          <p class="booster-modal-main-title">
            Buy Booster Minting Credits for {{ getEtherCostofBooster }} GLMR each
          </p>
          <p class="booster-modal-explain">
            Enter the # of booster NFT minting credits you would like to
            purchase:
          </p>
          <img
            class="booster-modal-icon"
            src="../components/assets/buy_booster_credits_icon.png"
          />
          <button
            class="booster-modal-buy-button"
            style="
              background-color: transparent;
              border-color: transparent;
              position: relative;
              display: block;
              margin-left: auto;
              margin-right: auto;
            "

            :disabled="(totalCreditsToBuy * getEtherCostofBooster) + 0.5 > getBalance"
            @click="buyBoosters"
          >
            <img
              class="booster-modal-image"
              src="../components/assets/buy_booster_credits_button.png"
            />
            <span
              :class="{
                'booster-modal-text': true,
                'grey-text': ((totalCreditsToBuy * getEtherCostofBooster) + 0.5 > getBalance),
              }"
              style="
                font-family: 'Truculenta', sans-serif;
                font-weight: 700;
              "
              >BUY CREDITS</span
            >
          </button>
          <p class="booster-modal-title">
            Booster NFT cards will NEVER be sold in the shop
          </p>
          <input
            id="toWallet"
            class="booster-modal-form"
            type="text"
            value="1"
            required
            @input="totalCreditsToBuy = $event.target.value"
          />
          <div class="booster-modal-close-button">
            <button
              block
              style="
                background-color: transparent;
                border-color: transparent;
                position: relative;
                display: block;
                margin-left: auto;
                margin-right: auto;
              "
              @click="$bvModal.hide('buy-boosters-modal')"
            >
              <span
                class="booster-modal-close"
                style="
                  font-family: 'Truculenta', sans-serif;
                  font-weight: 700;
                  font-size: 20px;
                "
                >CLOSE</span
              >
            </button>
          </div>
        </div>
      </b-modal>
      
      <!-- Open Probability Modal -->
      <b-modal
        id="open-probability-modal"
        title="Booster Minting Probability by Rarity"
        header-bg-variant="warning"
        centered
        hide-footer
        size="lg"
      >
        <div class="probablity-modal">
          <h4>
            The base probabilities of minting by rarity are hard coded in the
            Zoombies contract and will never change
          </h4>
          <div class="cards-image-container">
            <div class="booster-card-wrapper">
              <img
                src="https://zoombies.world/images/dapp/zoombies_card_epic_purple.svg"
              />
              <span class="rarity-text">Epic</span>
              <span class="prob-text">0.01%</span>
            </div>
            <div class="booster-card-wrapper">
              <img
                src="https://zoombies.world/images/dapp/zoombies_card_rare_red.svg"
              />
              <span class="rarity-text">Rare</span>
              <span class="prob-text">4.98%</span>
            </div>
            <div class="booster-card-wrapper">
              <img
                src="https://zoombies.world/images/dapp/zoombies_card_uncommon_blue.svg"
              />
              <span class="rarity-text uncommon">Uncommon</span>
              <span class="prob-text">29.9%</span>
            </div>
            <div class="booster-card-wrapper">
              <img
                src="https://zoombies.world/images/dapp/zoombies_card_common_brown.svg"
              />
              <span class="rarity-text common">Common</span>
              <span class="prob-text">64.9%</span>
            </div>
          </div>
        </div>
      </b-modal>

      <div>
        <UniverseBalances :is-in-own-crypt="true" />

        <h1 class="crypt-title">YOUR NFT CRYPT</h1>

        <!-- Loads cards here -->
        <div v-if="isWalletConnected" class="action-buttons">
          <div class="left-buttons">
            <OwnerBalances />
          </div>
          <div style="display: flex; flex-direction: column">
            <div class="info-button-container">
              <div id="crypt-nft-info-button" class="crypt-nft-info-button"></div>
            </div>
            <div class="right-buttons">
              <button
                v-b-tooltip.hover="'Mint 1 random booster NFT'"
                v-b-modal="'open-booster-modal'"
                class="booster-buttons"
              >
                <img
                  id="crypt-mint-booster-popover"
                  src="@/assets/mint_booster_nft_button.png"
                  class="mint_booster_nft_button"
                />
                <span class="mint_booster_nft_button_text">
                  MINT BOOSTER NFT
                </span>
              </button>
              <button
                v-b-tooltip.hover="'Mint 1 random booster NFT +200 ZOOM'"
                :disabled="getBalance < 1.01"
                class="booster-buttons"
                @click="buyAndOpenBooster"
              >
                <img
                  id="crypt-buy-mint-booster-popover" 
                  src="@/assets/buy_mint_booster_nft_button.png"
                  class="buy_mint_booster_nft_button"
                />
                <span class="buy_mint_booster_nft_button_text">
                  Buy & MINT BOOSTER NFT
                </span>
              </button>
              <button
                id="buy-boosters-btn"
                v-b-tooltip.hover="'Earn +700 ZOOM per credit'"
                v-b-modal.buy-boosters-modal
                :disabled="getBalance < 1.01 || isBuyingBooster"
                class="booster-buttons"
              >
              <img
                id="crypt-buy-credits-popover" 
                src="@/assets/buy_booster_nft_credits_button.png"
                class="buy_booster_nft_credits_button"
              />
                <span class="buy_booster_nft_credits_button_text">
                  BUY BOOSTER NFT CREDITS
                </span>
              </button>
            </div>
          </div>
        </div>
        <br />
        <div class="cards-wrapper">
          <cards-container
            :is-others-crypt="false"
            :address-to-load="getWalletAddress"
          />
        </div>
      </div>
    </div>
    <b-popover :show="Progression.stepIndex==2 && Progression.storyIndex==2" target="crypt-buy-credits-popover" triggers="manual hover" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.myZoombiesNfts[2].popovers[2].content }}
      </div>
    </b-popover>
    <b-popover :show="Progression.stepIndex==2 && Progression.storyIndex==4" target="crypt-buy-mint-booster-popover" triggers="manual hover" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.myZoombiesNfts[2].popovers[4].content }}
      </div>
    </b-popover>
    <b-popover :show="Progression.stepIndex==4 && Progression.storyIndex==1" target="crypt-mint-booster-popover" triggers="manual hover" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.myZoombiesNfts[4].popovers[1].content }}
      </div>
    </b-popover>
  </div>
</template>

<script>
import UniverseBalances from "@/components/UniverseBalances.vue";
import OwnerBalances from "@/components/OwnerBalances.vue";
import CardsContainer from "./CardsContainer.vue";
import {
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BProgress,
  BProgressBar,
  BPopover,
  BAlert,
  BContainer,
} from "bootstrap-vue";
import { showErrorToast } from "../util/showToast";
import dAppStates from "@/dAppStates";
import { mapGetters } from "vuex";
import { ethers } from "ethers";
import { calculateGasMargin } from "../store/blockChainStore";
import './assets/global.css';
import Typewriter from "typewriter-vue";
import Progress from './Progress.js';
import storyInstructions from "./story-instructions.json";
import { Progression } from './Progression.js'

export default {
  name: "CryptContent",
  components: {
    UniverseBalances,
    OwnerBalances,
    CardsContainer,
    BFormInput,
    BFormInvalidFeedback,
    BPopover,
    BProgress,
    BProgressBar,
    BAlert,
    BContainer,
    Typewriter
  },
  created() {
    this.ProgressInstance = new Progress();
    const progress = this.ProgressInstance.getProgress();

    if (progress.hasOwnProperty('myZoombiesNfts')) {
      Progression.stepIndex = progress.myZoombiesNfts;
    } else {
      Progression.stepIndex = 1;
    }
    this.ProgressInstance.updateProgress({name: 'myZoombiesNfts', value: Progression.stepIndex});

  },
  data() {
    return {
      storyInstructions,
      Progression,
      showSkipToast: false,
      wagerAmount: 0,
      receivingWallet: "",
      pBarDefaultValues: [1, 4.999, 29.999, 64.999],
      pBarWagerValues: [1, 4.99, 29.9, 64.9],
      pBarMax: 100,
      isBuyingBooster: false,
      totalCreditsToBuy: 1,
    };
  },
  computed: {
    ...mapGetters({
      getBalance: "blockChain/getBalance",
      getWalletAddress: "blockChain/getWalletAddress",
      getSignedZoombiesContract: "blockChain/getSignedZoombiesContract",
      getZoomBalance: "blockChain/getZoomBalance",
      getBoosterCreditOwned: "blockChain/getBoosterCreditOwned",
      getEtherCostofBooster: "blockChain/getEtherCostofBooster",
    }),
    isWalletConnected() {
      return this.$store.state.dAppState === dAppStates.WALLET_CONNECTED;
    },
    isWagerValid() {
      const wagerAmount = parseInt(this.wagerAmount);
      if (wagerAmount === 0) {
        return true;
      }

      if (this.getZoomBalance < wagerAmount) {
        return false;
      }

      return wagerAmount >= 1000000 && wagerAmount <= 20000000;
    },
    hasEnoughCZXP() {
      const wagerAmount = parseInt(this.wagerAmount);
      if (wagerAmount > 0) {
        return this.getZoomBalance > wagerAmount;
      }

      return true;
    },
    async getMyCryptLink() {
      // let url;
      // if (window.location.pathname === "/moonbase") {
      //   url = "https://moonbase.zoombies.world";
      // } else if (process.env.NODE_ENV === "development") {
      //   url = "localhost:8080";
      // } else {
      //   url = "https://movr.zoombies.world";
      // }

      // New implementation below

      let url;

      if (process.env.NODE_ENV === "development") {
        url = "localhost:8080";
      } else {
        url = "https://zoombies.world";
      }

      let curr_chain;
      const chainId = await window.ethereum.request({method: 'eth_chainId'});
      if(chainId == 0x507) {
        curr_chain = 'moonbase';
      }
      else if(chainId  == 0x504) {
        curr_chain = 'moonbeam';
      }

      return `${url}/${curr_chain}/my-zoombies-nfts/${this.getWalletAddress}`;
    },
  },
  watch: {
    getWalletAddress(val, oldVal) {
      if (val !== oldVal) {
        this.$bvModal.hide("gift-modal");
        this.$bvModal.hide("open-booster-modal");
      }
    },
  },
  mounted() {
    this.$root.$on('bv::popover::show', bvEventObj => {
      Progression.popOverSound.play();
    })

    this.$nextTick(() => {
      Progression.storyIndex = 0;

      const progress = this.ProgressInstance.getProgress();
      if (progress.hasOwnProperty('myZoombiesNfts')) {
        Progression.stepIndex = progress.myZoombiesNfts;
      } else {
        Progression.stepIndex = 1;

      }

      if (progress.myZoombiesNftsCompleted === false) {
        Progression.popOverSound.play();
        Progression.typingSound.currentTime = 83;
        Progression.typingSound.play();
        this.$bvModal.show('story-modal');
        console.log('showing tick - modal - crypt-content');
        console.log("step - story", Progression.stepIndex, Progression.storyIndex);
      }
    });
  },
  methods: {
    replacePanelText() {
      console.log('PANEL LENGTH', Object.keys(storyInstructions.myZoombiesNfts[Progression.stepIndex].story).length);

      if (Progression.storyIndex < storyInstructions.myZoombiesNfts[Progression.stepIndex].story.length - 1) {
        console.log(storyInstructions.myZoombiesNfts[Progression.stepIndex]);

        Progression.typingSound.currentTime = (Math.random() * 3) + 82;
        Progression.typingSound.play();

        this.$refs.typewriter.replaceText({
          from: storyInstructions.myZoombiesNfts[Progression.stepIndex].story[Progression.storyIndex],
          to: storyInstructions.myZoombiesNfts[Progression.stepIndex].story[Progression.storyIndex + 1],
        });
      }
      
      Progression.storyIndex++;
      console.log('STEP INDEX:', Progression.stepIndex ,' STORY INDEX:', Progression.storyIndex);
      
      // opening sponsor modal (**THIS CANNOT BE DONE IN HEADER, THE STORY MODAL WILL NOT OPEN**)
      if(Progression.stepIndex === 3 && Progression.storyIndex === 3) {
        this.$bvModal.hide('story-modal');
        this.$bvModal.show('open-probability-modal');
        this.$bvModal.show('story-modal');
      }
      if(Progression.stepIndex === 3 && Progression.storyIndex > 4) {
        this.$bvModal.hide('open-probability-modal');
      }
      if(Progression.stepIndex === 4 && Progression.storyIndex === 2) {
        this.$bvModal.hide('story-modal');
        this.$bvModal.show('open-booster-modal');
        this.$bvModal.show('story-modal');
      }
    },
    completePanelText() {
      this.$bvModal.hide('story-modal');

      // if (Progression.storyIndex === 4 && Progression.stepIndex === 7) {
      //   this.$bvModal.hide('sponsor-modal');
      // } 

      Progression.stepIndex++;
      this.ProgressInstance.updateProgress({name: 'myZoombiesNfts', value: Progression.stepIndex});

      if (Progression.stepIndex > Object.keys(storyInstructions.myZoombiesNfts).length) {
        Progression.stepIndex = Object.keys(storyInstructions.myZoombiesNfts).length;
        this.ProgressInstance.updateProgress({name: 'myZoombiesNfts', value: Progression.stepIndex});

        this.ProgressInstance.updateProgress({name: 'myZoombiesNftsCompleted', value: true});
        Progression.storyIndex = 6; // placeholder value
        Progression.storyCompletedSound.play();
      } else {
        this.$bvModal.show('story-modal');
        Progression.progressStepSound.play();
        Progression.storyIndex = 0; // placeholder value
        this.ProgressInstance.updateProgress({name: 'myZoombiesNftsCompleted', value: false});
      }
    },
    skipStoryProgress() {
      this.showSkipToast = true;

      Progression.stepIndex = Object.keys(storyInstructions.cardSets).length;// Specific for this page
      Progression.storyIndex = 6;
      this.ProgressInstance.updateProgress({name: 'myZoombiesNfts', value: 4});

      this.completePanelText();
    },
    buyBoosters: async function () {
      try {
        this.$bvModal.hide("buy-boosters-modal");
        this.isBuyingBooster = true;
        this.showTransactionModal();

        var totalBoostersCost = ethers.utils
          .parseEther((this.getEtherCostofBooster * parseInt(this.totalCreditsToBuy)).toString())
          .toString();

        const gasEstimate = await this.getSignedZoombiesContract.estimateGas.buyBoosterCredits(
          parseInt(this.totalCreditsToBuy),
          {
            value: totalBoostersCost.toString(),
          }
        );

        const res = await this.getSignedZoombiesContract.buyBoosterCredits(
          parseInt(this.totalCreditsToBuy),
          {
            value: totalBoostersCost.toString(),
            gasLimit: calculateGasMargin(gasEstimate),
          }
        );
        this.$store.dispatch("setIsTransactionConfirmed", true);

        await res.wait();
        this.$store.dispatch("setIsTransactionPending", false);
        this.$store.dispatch("setIsTransactionConfirmed", false);

        this.$store.dispatch("blockChain/updateWalletBalances");
        this.$store.dispatch("blockChain/updateUniverseBalances");
      } catch (error) {
        console.error(error);
        if (error.code == 'ACTION_REJECTED') {
          showErrorToast(this, "Request cancelled");
        }
        else {
          showErrorToast(this, "Failed to get booster credit");
        }
      } finally {
        this.isBuyingBooster = false;
        this.hideTransactionModal();
      }
    },
    setLastMintTime() {
      const nowSec = Date.now() / 1000;
      localStorage.setItem("lastMintTime", nowSec);
    },
    buyAndOpenBooster: async function () {
      try {
        this.$store.dispatch("setIsTransactionPending", true);
        this.$store.dispatch("setIsSacrificeEvent", false);
        this.setLastMintTime();

        const gasEstimate = await this.getSignedZoombiesContract.estimateGas.buyBoosterAndMintNFT(
          {
            value: ethers.utils.parseEther((this.getEtherCostofBooster).toString()).toString(),
          }
        );

        const res = await this.getSignedZoombiesContract.buyBoosterAndMintNFT({
          value: ethers.utils.parseEther((this.getEtherCostofBooster).toString()).toString(),
          gasLimit: calculateGasMargin(gasEstimate),
        });
        this.$store.dispatch("setIsTransactionConfirmed", true);

        await res.wait();
        this.$store.dispatch("setIsTransactionPending", false);
        this.$store.dispatch("setIsTransactionConfirmed", false);
        this.$store.dispatch("blockChain/updateWalletBalances");
        this.$store.dispatch("blockChain/updateUniverseBalances");
      } catch (err) {
        console.error(err);
        if (err.code == 'ACTION_REJECTED') {
          showErrorToast(this, "Request cancelled");
        }
        else {
          showErrorToast(this, "Failed to buy/open booster");
        }
      } finally {
        this.$bvModal.hide("open-booster-modal");
        this.$store.dispatch("setIsTransactionPending", false);
        this.$store.dispatch("setIsTransactionConfirmed", false);
      }
    },
    openBooster: async function () {
      this.setLastMintTime();
      try {
        this.$store.dispatch("setIsTransactionPending", true);
        this.$store.dispatch("setIsSacrificeEvent", false);     
        this.$bvModal.hide("open-booster-modal");

        const gasEstimate = await this.getSignedZoombiesContract.estimateGas.mintBoosterNFT(
          this.wagerAmount
        );

        const res = await this.getSignedZoombiesContract.mintBoosterNFT(
          this.wagerAmount,
          { gasLimit: calculateGasMargin(gasEstimate) }
        );
        this.$store.dispatch("setIsTransactionConfirmed", true);
        await res.wait();
        this.$store.dispatch("setIsTransactionPending", false);
        this.$store.dispatch("setIsTransactionConfirmed", false);
        this.$store.dispatch("blockChain/updateWalletBalances");
        this.$store.dispatch("blockChain/updateUniverseBalances");
      } catch (err) {
        console.error(err);
        if (err.code == 'ACTION_REJECTED') {
          showErrorToast(this, "Request cancelled");
        }
        else {
          showErrorToast(this, "Failed to open booster");
        }
        this.$store.dispatch("setIsTransactionPending", false);
        this.$store.dispatch("setIsTransactionConfirmed", false);
      }
    },
    showTransactionModal() {
      this.$store.dispatch("setIsTransactionPending", true);
      this.$store.dispatch("setIsSacrificeEvent", false);
    },
    hideTransactionModal() {
      this.$store.dispatch("setIsTransactionPending", false);
      this.$store.dispatch("setIsTransactionConfirmed", false);
    },
    calculateProbability: function () {
      if (this.wagerAmount < 1000000 || this.wagerAmount > 20000000) {
        this.wagerAmount = 0;
        this.pBarWagerValues = this.pBarDefaultValues;
        return;
      }

      let e = 1 + this.wagerAmount / 20000;
      let r = 500 + e + this.wagerAmount / 5500;
      let u = 3500 + r + this.wagerAmount / 8000;

      let eP = (e / 10000) * 100;
      let rP = Math.floor(((r - e) / 10000) * 100);
      let uP = Math.floor(((u - r) / 10000) * 100);
      let cP = 100 - (eP + rP + uP);

      if (cP < 0) {
        cP = 0;
        uP = 100 - (eP + rP);
      }

      this.pBarWagerValues = [eP, rP, uP, cP];
    },
  },
};
</script>

<style scoped lang="scss">
.no-zoom-text{
  color: #ffffff;
  text-align: center;

}

button {
  white-space: nowrap !important;
}

::v-deep .modal-content {
  background-color: transparent;
  border: none;
}

.modal-content {
  background-color: transparent;
}

.modal-content.booster-modal {
  background-color: transparent;
}

.action-buttons {
  display: flex;
  align-items: center;

  button {
    height: 50px;

    &:hover {
      transform: scale(1.05);
    }
  }

  @media screen and (min-width: 685px) {
    flex-direction: row;
    justify-content: space-between;
  }

  div {
    margin: 6px;
  }

  .left-buttons {
    margin-top: 0px;
    display: flex;
    align-items: center;

    .booster-counter {
      position: relative;
      border-radius: 50%;
      background: white;
      border: 2px solid black;
      padding: 0 2px 0 4px;
      color: black;
      margin-right: 15px;

      svg {
        position: absolute;
        right: 0;
        top: 7%;
        transform: translateX(65%);
      }
    }
  }
}

.right-buttons {
    display: flex;
    flex-direction: row;

    button {
      margin-left: 10px;
    }
}

.crypt-title {
  padding-left: 12px;
  margin-bottom: 0px;
  font-family: Truculenta; 
  font-weight: 700;
}

.default-probability {
  padding-top: 32px;
  font-family: "Truculenta", sans-serif;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}

.open-booster-modal {
  background-image: url("../components/assets/mint_booster_bg.png");
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  width: fit-content;
  height: 750px;
}

.form-description {
  padding-top: 210px;
  padding-left: 140px;
  padding-right: 140px;
  font-family: "Truculenta", sans-serif;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}

.text-danger-before {
  margin-top: 43px;
  font-family: "Truculenta", sans-serif;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}

.mint-button {
  margin-left: 200px;
  margin-right: 200px;
}

.mint-button-image {
  height: 60px;
  width: auto;
}

.mint-button-image-disabled {
  height: 60px;
  width: 180px;
}

.mint-button-text {
  color: #ffffff;
  font-size: 22px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.close-button {
  padding-left: 300px;
  padding-right: 300px;
  padding-bottom: 20px;
}

.close-button-text {
  color: #ffffff;
  position: absolute;
  transform: translate(-285%, 35%);
}

.min-max-wager {
  font-family: "Truculenta", sans-serif;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
}

.zoom-wager {
  font-family: "Arial";
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}

.booster-modal-content {
  background-image: url("../components/assets/buy_booster_credits_bg.png");
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  width: fit-content;
  height: 750px;
}

.booster-modal-main-title {
  padding-left: 70px;
  padding-right: 70px;
  padding-top: 270px;
  font-family: "Truculenta", sans-serif;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}

.booster-modal-title {
  padding-left: 150px;
  padding-right: 150px;
  margin-bottom: 0px;
  font-family: "Truculenta", sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: #ffffff;
  margin-bottom: 0px;
}

.booster-modal-explain {
  padding-left: 130px;
  padding-right: 130px;
  margin-bottom: 2px;
  font-family: "Truculenta", sans-serif;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  color: #00D1FF;
}

.booster-modal-close {
  font-family: "Truculenta", sans-serif;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}

.booster-modal-icon {
  padding-left: 160px;
  height: 55px;
  width: auto;
}

.booster-modal-form {
  transform: translate(290%, -535%);
  width: 75px;
  color: #ffffff;
  border: 1px solid #1E162F;
  border-radius: 1px;
  background-color : #1E162F;
}

.booster-modal-image {
  margin-top: 5px;
  height: 50px;
}

.booster-modal-text {
  font-size: 20px;
  color: #ffffff;
  position: absolute;
  transform: translate(-135%, 40%);
}

.grey-text {
  color: #b5b5b5;
}

.booster-modal-close {
  color: #ffffff;
  position: absolute;
}

.booster-modal-close-button {
  padding-left: 200px;
  padding-right: 200px;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  position: absolute;
  right: 5%;
}

.booster-buttons {
  background-color: transparent;
  border-color: transparent;
  position: relative;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.mint_booster_nft_button {
  width: 200px;
}

.buy_mint_booster_nft_button {
  width: 200px;
}

.buy_booster_nft_credits_button {
  width: 200px;
}

.mint_booster_nft_button_text {
  font-family: 'Truculenta', sans-serif;
  font-weight: 700;
  font-size: 16px;
  position: absolute;
  transform: translate(-145%, 30%);
}

.buy_mint_booster_nft_button_text {
  font-family: 'Truculenta', sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  position: absolute;
  transform: translate(-120%, 30%);
}

.buy_booster_nft_credits_button_text {
  font-family: 'Truculenta', sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;  
  position: absolute;
  transform: translate(-115%, 30%);
}

.right-buttons {
    button:disabled {
      .buy_mint_booster_nft_button_text, .buy_booster_nft_credits_button_text {
        color: #b5b5b5;
      }
  }
}

.crypt-nft-info-popover {
  width: 1000px;
  background: linear-gradient(0deg, #111324, #111324), #1E162F !important;
  border: 4px solid #00D1FF;
  box-shadow: 15px 15px 15px rgba(0, 0, 0, 0.4);
  border-radius: 20px;
}

.crypt-nft-description {
  font-family: 'Truculenta', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: rgba(255, 255, 255, 1);
  padding: 10px 10px 10px 10px;
  margin-bottom: 0px;
}

.info-button-container {
  margin-right: 0;
  height: 35px;
  display: flex;
  justify-content: flex-end;
}

.crypt-nft-info-button {
  background-color: transparent;
  background-image: url("assets/help.webp");
  background-size: contain;
  background-repeat: no-repeat;
  border: none;
  width: 35px;
  height: 35px;

  animation: float 4s ease-in-out infinite;

  &:hover {
    animation-play-state: paused;
  }
}

.confirm-next-button {
  position: absolute;
  top: 0px;
  right: 10px;
  background-color: transparent;
  border-color: transparent;
  position: relative;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: auto;
}

.confirm-next-button-image {
  float: right;
  width: 8%;
  height: auto;
}

@keyframes float {
	0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-15px);
	}
	100% {
		transform: translatey(0px);
	}
}

@media screen and (max-width: 800px) {
  .open-booster-modal {
    background-image: url("../components/assets/mint_booster_bg_mobile.png");
    background-color: transparent;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 200%;
    width: 100%;
    height: 750px;
  }

  .form-description {
    padding-top: 195px;
    padding-left: 50px;
    padding-right: 50px;
    font-family: "Truculenta", sans-serif;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
  }

  .mint-button {
    margin-left: 200px;
    margin-right: 200px;
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;
    position: absolute;
    right: -10%;
  }

  .mint-button-image {
    height: 50px;
  }

  .mint-button-text {
    color: #ffffff;
    position: absolute;
    transform: translate(-150%, 35%);
  }

  .close-button {
    padding-left: 200px;
    padding-right: 200px;
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;
    position: absolute;
    right: -10%;
  }

  .close-button-text {
    color: #ffffff;
    position: absolute;
    transform: translate(-285%, 35%);
  }

  .text-danger-before {
    padding-top: 68px;
    font-family: "Truculenta", sans-serif;
    font-size: 10px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
  }

  .min-max-wager {
    padding-top: 2px;
    padding-right: 9px;
    padding-bottom: 5px;
    font-family: "Truculenta", sans-serif;
    font-size: 11px;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
  }

  .zoom-wager {
    font-family: "Arial";
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
  }

  .default-probability {
    padding-top: 40px;
    font-family: "Truculenta", sans-serif;
    font-size: 13px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
  }

  .booster-modal-content {
    background-image: url("../components/assets/buy_booster_credits_bg.png");
    background-color: transparent;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    width: fit-content;
    height: 500px;
  }

  .booster-modal-main-title {
    padding-left: 70px;
    padding-right: 70px;
    padding-top: 170px;
    font-family: "Truculenta", sans-serif;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
  }

  .booster-modal-title {
    padding-left: 110px;
    padding-right: 110px;
    font-family: "Truculenta", sans-serif;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
  }
  
  .booster-modal-explain {
    padding-left: 90px;
    padding-right: 90px;
    margin-bottom: 2px;
    font-family: "Truculenta", sans-serif;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    color: #00D1FF;
  }

  .booster-modal-close {
    font-family: "Truculenta", sans-serif;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
  }

  .booster-modal-icon {
    padding-left: 110px;
    height: 45px;
    width: auto;
  }

  .booster-modal-form {
    transform: translate(225%, -410%);
    width: 70px;
    color: #ffffff;
    border: 1px solid #1E162F;
    border-radius: 1px;
    background-color : #1E162F;
  }

  .booster-modal-image {
    margin-top: 0px;
    height: 35px;
  }

  .booster-modal-text {
    font-size: 15px;
    color: #ffffff;
    position: absolute;
    transform: translate(-130%, 25%);
  }
  .grey-text {
    color: #b5b5b5;
  }

  .booster-modal-close {
    color: #ffffff;
    position: absolute;
  }

  .booster-modal-close-button {
    padding-left: 200px;
    padding-right: 200px;
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;
    position: absolute;
    transform: translate(2%, -250%);
  }

  .right-buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    button {
      margin-left: 10px;
    }
  }

  .booster-buttons {
    background-color: transparent;
    border-color: transparent;
    position: relative;
    display: block;
  }

  .mint_booster_nft_button {
    width: 200px;
  }

  .buy_mint_booster_nft_button {
    width: 200px;
  }

  .buy_booster_nft_credits_button {
    width: 200px;
  }

  .mint_booster_nft_button_text {
    font-family: 'Truculenta', sans-serif;
    font-weight: 700;
    font-size: 16px;
    position: absolute;
    transform: translate(-145%, 30%);
  }

  .buy_mint_booster_nft_button_text {
    font-family: 'Truculenta', sans-serif;
    font-weight: 700;
    font-size: 16px;
    color: #ffffff;
    position: absolute;
    transform: translate(-120%, 30%);
  }

  .buy_booster_nft_credits_button_text {
    font-family: 'Truculenta', sans-serif;
    font-weight: 700;
    font-size: 16px;  
    color: #ffffff;
    position: absolute;
    transform: translate(-115%, 30%);
  }

  .crypt-nft-info-popover {
    width: 1000px;
    background: linear-gradient(0deg, #111324, #111324), #1E162F !important;
    border: 4px solid #00D1FF;
    box-shadow: 15px 15px 15px rgba(0, 0, 0, 0.4);
    border-radius: 20px;
  }

  .crypt-nft-description {
    font-family: 'Truculenta', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    padding: 10px 10px 10px 10px;
    margin-bottom: 0px;
  }

  .crypt-nft-info-button {
    background-color: transparent;
    background-image: url("assets/help.webp");
    background-size: contain;
    background-repeat: no-repeat;
    border: none;
    width: 45px;
    height: 45px;
    transform: translate(0%, 0%);
  }
}

@media screen and (max-width: 950px) {
  .action-buttons {
    flex-direction: column;

    .left-buttons {
      flex-direction: column;
    }
  }
}

.buy-and-open-booster {
  display: flex;
  background-color: transparent;
  background-image: url("assets/pink_button_wide.png");
  background-size: 100% 100%;
  border: none;
  color: #111;
  font-weight: 650;
  padding: 10px 14px;
}

#open-booster-modal div {
  // margin-bottom: 10px;
}

.cards-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: 800px) {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .booster-card-wrapper {
    position: relative;
    width: 250px;

    @media screen and (min-width: 800px) {
      width: 300px;
    }

    img {
      width: 100%;
    }

    .rarity-text {
      color: white;
      font-size: 22px;
      font-weight: bold;
      text-align: center;
      position: absolute;
      right: 41%;
      top: 61%;

      @media screen and (min-width: 800px) {
        right: 43%;
      }
    }

    .prob-text {
      color: white;
      font-size: 48px;
      position: absolute;
      top: 26%;
      left: 28%;
      text-align: center;

      @media screen and (min-width: 800px) {
        top: 30%;
        left: 30%;
      }
    }

    .uncommon {
      right: 24%;

      @media screen and (min-width: 800px) {
        right: 28%;
      }
    }
    .common {
      right: 32%;

      @media screen and (min-width: 800px) {
        right: 34%;
      }
    }
  }
}

.probablity-modal {
  padding: 0 12px;
  width: 100%;

  h4 {
    text-align: center;
    margin-bottom: 16px;
  }
}

.mint-booster-btn {
  background-color: transparent;
  background-image: url("assets/pink_button_wide.png");
  background-size: 100% 100%;
  border: none;
  color: #111;
  font-weight: 650;
  padding: 10px 14px;

  &.disabled {
    color: #444;
  }
}

.mr-icon {
  height: 20px;
  margin-left: 5px;
}

.b-progress-bar-purple {
  background-color: #b92ee4;
  color: red;
}
.p-bar-purple {
  background-color: var(--purple);
}

</style>
